/**
 * What a donor is told when a new card cannot be saved, shared by the portal's update dialog and the
 * payment-update page a dunning email links to.
 *
 * The gateway checks a new card with the bank before it is saved (a setup intent, which charges
 * nothing). When the bank or the gateway refuses, nothing has changed: the old card is still the one
 * in use. The message says why, in the gateway's own donor-safe words when it gave some, and what to do.
 */

/**
 * @param {string} text
 * @return {string}
 */
function t( text ) {
	return window.wp && window.wp.i18n ? window.wp.i18n.__( text, 'anudan' ) : text;
}

/**
 * @param {{type?: string, message?: string}|undefined} error What the gateway's confirm call returned.
 * @return {string} A plain sentence or two: why, that nothing changed, and what to do next.
 */
export function plainFailureMessage( error ) {
	const why = error && 'card_error' === error.type && error.message
		? error.message
		: t( 'We could not verify this card with your bank.' );

	return `${ why } ${ t( 'Your current payment method is still in use and nothing has been changed. Please check the card number, expiry date and security code, or try a different card.' ) }`;
}

/**
 * Tells the server a new card could not be saved, so the donor is emailed (at most once an hour for
 * each recurring gift — the server decides). Best effort: a failed report never changes what the
 * donor sees.
 *
 * @param {string}   restRoot Where the REST routes live.
 * @param {string}   path     The report route, relative to the REST root.
 * @param {Object}   [headers] Extra request headers (the portal's REST nonce).
 * @return {Promise<void>}
 */
export async function reportFailure( restRoot, path, headers = {} ) {
	try {
		await fetch( restRoot + path, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', ...headers },
			body: '{}',
			credentials: 'same-origin',
		} );
	} catch ( error ) {
		// Nothing to do: the donor already has the on-screen message.
	}
}
